// extracted by mini-css-extract-plugin
export default {"question":"Question_question__xC8RZ","line":"Question_line__nHWXw"};